import { __awaiter } from '../../../_virtual/_tslib.js';
import { useContainer } from '@hub-la/fe-container';
import { Analytics } from '@hub-la/fe-core-analytics';
import { HttpClient } from '@hub-la/fe-core-http-client';
import { useQuery } from 'react-query';
import '../../domain/dtos/alert-type.js';
import '../../domain/dtos/error-type.js';
import { Events } from '../../domain/dtos/events.js';
import '../../domain/dtos/main-content-type.js';
import '../../domain/dtos/post-event-type.js';
import { PostStatus } from '../../domain/dtos/post-status.js';
import '../../domain/dtos/query-key.js';
import '../../domain/dtos/remove-dialog-action.js';
import { GetPostUseCase } from '../../usecases/get-post.js';
import { useGetSectionProgress } from './use-get-section-progress.js';
import { useMarkPostViewed } from './use-mark-post-viewed.js';
import { useRealtimeSections } from './use-realtime-sections.js';

const useGetPost = input => {
  const container = useContainer();
  const markPostViewed = useMarkPostViewed();
  const {
    mutateAsync: getSectionProgress
  } = useGetSectionProgress();
  const {
    dispatch
  } = useRealtimeSections();
  //const { data: currentUser } = useCurrentUser()
  //TOOD: Get the current user from the context
  const currentUser = {
    id: '1'
  };
  const currentUserId = currentUser === null || currentUser === void 0 ? void 0 : currentUser.id;
  const analytics = container.get(Analytics);
  return useQuery(['get-post', input.postId], () => new GetPostUseCase(container.get(HttpClient)).fetch(input), {
    retryOnMount: false,
    refetchOnWindowFocus: false,
    initialData: undefined,
    retry: false,
    keepPreviousData: true,
    staleTime: Infinity,
    cacheTime: Infinity,
    onSuccess: data => __awaiter(void 0, void 0, void 0, function* () {
      var _a;
      if (!data.viewed && data.status === PostStatus.PUBLISHED) {
        yield markPostViewed.mutateAsync(data.id);
        const sectionProgress = yield getSectionProgress(data.sectionId);
        dispatch({
          type: 'update',
          postId: data === null || data === void 0 ? void 0 : data.id,
          sectionId: data === null || data === void 0 ? void 0 : data.sectionId,
          viewed: true,
          sectionProgress
        });
      }
      analytics.track(Events.HUB.POST_VIEWED, {
        userId: currentUserId,
        productId: (_a = data === null || data === void 0 ? void 0 : data.product) === null || _a === void 0 ? void 0 : _a.id,
        postId: input === null || input === void 0 ? void 0 : input.postId,
        name: data === null || data === void 0 ? void 0 : data.title
      });
    })
  });
};

export { useGetPost };
